import { Api } from "@noom/noomscape";

import axios from "axios";

/**
 * Subset of CoachServer's `UserProgramMetadata` that we read. Members can call
 * this for their own access code; it 404s when the user is not in a program.
 */
export type UserProgramInfo = {
  partnerId?: string;
  partnerName?: string;
  partnerSlug?: string;
};

Api.register(
  "userProgram.getUserProgramInfo",
  async ({
    accessCode,
    accessToken,
  }: {
    accessCode: string;
    accessToken: string;
  }) => {
    const response = await axios({
      baseURL: window.ENV.SERVER_URL,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      method: "GET",
      url: `/users/${accessCode}/programs/info`,
      urlWithPathParams: "/users/{accessCode}/programs/info",
    });

    return response.data as UserProgramInfo;
  },
);
